import {createAction} from "redux-act";
import type {BadgeType} from 'modules/enums';

export interface IRewardStatsResponse {
	rewards: IRewardStat[];
}

export interface IRewardStat {
	reward: BadgeType;
	earnedPercentage: number;
	rarity: string;
	color: string;
}

export const fetchRewardStats = createAction();
export const fetchRewardStatsSuccess = createAction<IRewardStatsResponse>();
export const fetchRewardStatsErrors = createAction();
